/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseAmazonItems } from './ResponseAmazonItems';
import {
    ResponseAmazonItemsFromJSON,
    ResponseAmazonItemsFromJSONTyped,
    ResponseAmazonItemsToJSON,
    ResponseAmazonItemsToJSONTyped,
} from './ResponseAmazonItems';

/**
 * 
 * @export
 * @interface ResponseGetAmazonItemsListResponse
 */
export interface ResponseGetAmazonItemsListResponse {
    /**
     * 
     * @type {Array<ResponseAmazonItems>}
     * @memberof ResponseGetAmazonItemsListResponse
     */
    items?: Array<ResponseAmazonItems>;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetAmazonItemsListResponse
     */
    totalCount?: number;
}

/**
 * Check if a given object implements the ResponseGetAmazonItemsListResponse interface.
 */
export function instanceOfResponseGetAmazonItemsListResponse(value: object): value is ResponseGetAmazonItemsListResponse {
    return true;
}

export function ResponseGetAmazonItemsListResponseFromJSON(json: any): ResponseGetAmazonItemsListResponse {
    return ResponseGetAmazonItemsListResponseFromJSONTyped(json, false);
}

export function ResponseGetAmazonItemsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetAmazonItemsListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(ResponseAmazonItemsFromJSON)),
        'totalCount': json['total_count'] == null ? undefined : json['total_count'],
    };
}

export function ResponseGetAmazonItemsListResponseToJSON(json: any): ResponseGetAmazonItemsListResponse {
    return ResponseGetAmazonItemsListResponseToJSONTyped(json, false);
}

export function ResponseGetAmazonItemsListResponseToJSONTyped(value?: ResponseGetAmazonItemsListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(ResponseAmazonItemsToJSON)),
        'total_count': value['totalCount'],
    };
}

